import { TextField, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';

import {
  useGetPieceAssignmentErrorReportsByPieceQuery,
  useUpsertPieceAssignmentErrorReportMutation,
} from '@api/pieceAssignmentErrorReport';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { getIsInReceiveSession } from '@utils/helpers';

interface ReportProps {
  pieceId?: number;
  onClose: () => void;
}

const Report: FC<ReportProps> = ({ pieceId, onClose }) => {
  const isInReceiveSession = getIsInReceiveSession();
  const [reportComment, setReportComment] = useState('');

  const [upsertReport, { isLoading }] = useUpsertPieceAssignmentErrorReportMutation();
  const { data: existingReports } = useGetPieceAssignmentErrorReportsByPieceQuery(pieceId || 0);

  useEffect(() => {
    setReportComment(existingReports?.[0]?.message ?? '');
  }, [existingReports]);

  const handleReportSubmit = async () => {
    if (!pieceId) return;
    try {
      await upsertReport({
        pieceId,
        message: reportComment.trim() || undefined,
      }).unwrap();
      onClose();
    } catch (error) {
      console.error('Failed to save report:', error);
      return;
    }
  };

  return (
    <DialogConfirmation
      open
      title="Report assignment issue"
      darkMode={!!isInReceiveSession}
      content={
        <>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            Help us improve Auto-Assign by reporting an issue with this item.
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Optional Comment"
            value={reportComment}
            onChange={(e) => setReportComment(e.target.value)}
          />
        </>
      }
      acceptButtonTitle="Submit"
      cancelButtonTitle="Cancel"
      acceptButtonHandleClick={handleReportSubmit}
      cancelButtonHandleClick={onClose}
      loading={isLoading}
      maxWidth="xs"
    />
  );
};

export { Report };
